import React, { memo, useContext, useCallback } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { LayoutMode } from '../../types';
import { GridIcon } from './icons/grid-icon';
import { ListIcon } from './icons/list-icon';

import * as S from './styles';

type Props = {
  mode: LayoutMode;
  active: boolean;
  onClick: (mode: LayoutMode) => void;
};

const LayoutPicker = ({ mode, onClick, active }: Props) => {
  const { t } = useContext(AppContext);

  const setListMode = useCallback(() => onClick(mode), [mode, onClick]);

  return (
    <S.LayoutButton
      onClick={setListMode}
      aria-label={t(
        'category',
        mode === LayoutMode.GRID
          ? 'product-list.grid-layout-button'
          : 'product-list.list-layout-button'
      )}
      active={active}
      data-test={`layout-button-${mode}`}
    >
      {mode === LayoutMode.GRID ? (
        <GridIcon size={24} />
      ) : (
        <ListIcon size={24} />
      )}
    </S.LayoutButton>
  );
};

export default memo(LayoutPicker);
